var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Router = ReactRouter.Router;
var Route = ReactRouter.Route;
var IndexRoute = ReactRouter.IndexRoute;
var Link = ReactRouter.Link;
var createBrowserHistory = require('history/lib/createBrowserHistory');
var RouteTransition = require('./route-transition');
var Shopify = require('./shopify');
var Home = require('./home');
var NavBar = require('./nav-bar');
var Footer = require('./footer');
var ArtOfFit = require('./art-of-fit');
var Mens = require('./mens');
var Womens = require('./womens');
var Collection = require('./collection');
var ScreenWid = require('./stores/screen-wid-store');
var ProdDetail = require('./product-detail');
var BagPage = require('./bag-page');
var Stores = require('./stores');
var StyleTips = require('./style-tips');
var BlogPage = require('./blog-page');
var Search = require('./search');
var BrandsPageM = require('./brands-mens');
var BrandsPageW = require('./brands-womens');
var Help = require('./help');
var ShippingReturns = require('./shipping-returns');
var Career = require('./career');
var Giftcard = require('./giftcard');
var Privacy = require('./privacy-policy');

var ThankYou = React.createClass({

  
  getInitialState: function() {
    return { title: "Thank You",
             message: "",
             btnText: "KEEP SHOPPING" }
  },

  rawMarkup: function() {
    return { __html: this.state.message };
  },

  setContent: function(msg, title, btnText) {
    this.setState({ title: title ? title : "Thank You",
                    message: msg,
                    btnText: btnText ? btnText : "KEEP SHOPPING" });
  },

  render: function() {
    return <div className="modal fade" id="request-thank-you" tabIndex="-1" role="dialog"
                aria-labelledby="requestFittingThankYou">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h3 className="modal-title">{this.state.title}</h3>
                <div dangerouslySetInnerHTML={this.rawMarkup()}></div>
                <button type="button" className="btn btn-primary btn-wide" data-dismiss="modal">{this.state.btnText}</button>
            </div>
        </div>
      </div>
  }
});

var BlockerFiltering = React.createClass({

  render: function() {
    return <div className="modal fade" id="blocker-filtering" tabIndex="-1" role="dialog"
                aria-labelledby="filtering">
               <div className="modal-dialog loader-modal" role="document">
                   <div className="modal-content">
                       <div><img className="loader" src={loaderImg}></img></div>
                   </div>
               </div>
           </div>
  }
});

var RequestFittingForm = React.createClass({

  thanksMsg: CMS.misc.thanks_msg_fitting_req.replace(/____/g, "<br/>"),
                                             
  componentDidMount: function() {
    var date = new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000);
    var day = date.getDate();
    var month  = date.getMonth() + 1;
    var year = date.getFullYear();
    var minD = year + '/' + month  + '/' + day;
    jQuery(this.refs.preferTime).datetimepicker({
        formatDate:'Y/m/d',
        minDate: minD,
        minTime:'10:00',
        maxTime:'16:00',
        step: 15,
        defaultTime: '10:00'
    });
    var submitHandler = function(form) {
            jQuery('#request-form').modal('hide');

            function clearForm(self) {
                jQuery(self.refs.email).val("");
                jQuery(self.refs.phone).val("");
                jQuery(self.refs.newsletters).prop('checked', false);
                jQuery(self.refs.store).val(""),
                jQuery(self.refs.preferTime).val("");
              }
            jQuery.post("/contact",
                        { form_type: "contact",
                          utf8: "✓",
                          "contact[tags]": "fitting-request",
                          "contact[email]": jQuery(this.refs.email).val(),
                          "contact[phone]": jQuery(this.refs.phone).val(),
                          "contact[newsletters]": jQuery(this.refs.newsletters).prop('checked'),
                          "contact[store]": jQuery(this.refs.store).val(),
                          "contact[preferTime]": jQuery(this.refs.preferTime).val() },
                        function(result) {
                          clearForm(this);
                          this.props.showThankYou(this.thanksMsg);
                        }.bind(this))          
              .error(function(e) {
                clearForm(this);
                this.props.showThankYou(this.thanksMsg);
              }.bind(this));
        }.bind(this);
    jQuery(this.refs.form).validate({
        rules: {
            email: {
              required: true,
              email: true
            }
        },
        submitHandler: submitHandler
    });
  },

  setStore: function(store) {
    jQuery(this.refs.store).val(store);
  },

  rawMarkup: function() {
    return { __html: CMS.misc.requestFittingW.replace(/____/g, "<br/>") };
  },

  render: function() {
    var i = 0;
    var stores = CMS.stores.stores.map(function(store) {
                     i++;
                     return <option value={store.title} key={i}>{store.title}</option>;
                 });
    return <div className="modal fade" id="request-form" tabIndex="-1" role="dialog"
                aria-labelledby="requestFittingForm">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            <div className="modal-header">
                <h3 className="modal-title">{CMS.misc.requestFittingTitle}</h3>
                <div dangerouslySetInnerHTML={this.rawMarkup()}></div> 
            </div>
            <form ref="form">
                <div className="modal-body" >
                    <input type="text" ref="email" name="email" placeholder="YOUR EMAIL*" className="form-control" required email>
                    </input>
                    <input type="text" ref="phone" placeholder="YOUR PHONE NUMBER" className="form-control">
                    </input>
                    <div className="styled-select arrow-right">
                        <div className="select-default">LOCATION</div>
                        <select className="form-control" ref="store" defaultValue="">
                            <option value="" disabled>LOCATION</option>
                            {stores}
                        </select>
                    </div>
                    <input type="text" placeholder="PREFERRED DATE & TIME" className="form-control"
                           ref="preferTime">
                    </input>
                    <div className="form-group checkbox-div">
                        <label className="checkbox-label">
                            <input type="checkbox" value="newsletters" name="newsletters" ref="newsletters" />
                            <span className="styled-checkbox"></span>{CMS.misc.req_fitting_checkbox_text}
                        </label>
                    </div>
                </div>
                <div className="modal-footer">
                    <input type="submit" className="btn btn-primary btn-wide" value={CMS.misc.req_fitting_button_text} />
                </div>
            </form>
          </div>
        </div>
      </div>
  }
});

var Page = React.createClass({
  mixins: [ ScreenWid ],
  curRoute: "",
  prevRoute: "",

  componentDidMount: function() {

    jQuery(document).on('change', '.styled-select select', function(){
        var defaultText = jQuery(this).find(':selected').text();
        jQuery(this).prev().text(defaultText);
    });

    var navH = jQuery('.nav-top').outerHeight() + jQuery('.main-nav').outerHeight();
    jQuery('body').css('padding-top', navH);
    if(ScreenWid.width == 'LG') {
        jQuery('body.gender-page, body.collection-page').css('padding-top', navH + jQuery('#submenu').outerHeight());
    }

    jQuery('#submenu').css('top', navH);
    jQuery('.gender-page #submenu, .collection-page #submenu, .brand-page #submenu').css('top', 'auto');
    jQuery('#bag-popup').css('top', jQuery('.main-nav').outerHeight());


    function isScrolledIntoView(elem)
    {
        var $window = jQuery(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = elem.offset().top;
        var elemBottom = elemTop + elem.height();
        return  ((( elemTop >= docViewTop) && (elemTop <= docViewBottom)) || ((elemBottom >= docViewTop) && (elemBottom <= docViewBottom)) || ((elemTop <= docViewTop) && (elemBottom >= docViewBottom))) ;
    }

    jQuery(window).scroll(function(){
        jQuery('.fade-in').each(function(){
            var elem = jQuery(this);
            if (isScrolledIntoView(elem)) {
                elem.addClass('shown');
            } else {
                elem.removeClass('shown');
            }
        });
    })
    jQuery(window).scroll(); // trigger scroll to show elements already in viewport

    this.prevRoute = this.curRoute,
    this.curRoute = this.props.location.pathname;
  },

  componentWillReceiveProps: function(nextProp) {
    this.prevRoute = this.curRoute,
    this.curRoute = nextProp.location.pathname;
  },

  handleAddToBag: function(id) {
    Shopify.addToCart(id, 1, this.handleAddToBagResponse);
  },

  handleUpdateBag: function(cart) {
    this.refs.navBar.updateBag(cart);
  },

  handleAddToBagResponse: function(succeeded, result) {
    if (succeeded) {
      this.showBag();
    } else {
      this.showThankYou(result, "Out of stock", "OK")
    }
  },

  showBag: function() {
    this.refs.navBar.showBag();
  },

  showFittingReqForm: function(store) {
    if (store) {
      this.refs.requestFittingForm.setStore(store);
    }

    // iOS check...to fix iOS bug when position:fixed and virtual keyboards triggered
    if( navigator.userAgent.match(/iPhone|iPad|iPod/i) ) {
        jQuery('.modal').on('show.bs.modal', function() {
            // Position modal absolute and bump it down to the scrollPosition
            jQuery(this)
                .css({
                    position: 'absolute',
                    marginTop: $(window).scrollTop() + 'px',
                    bottom: 'auto'
                });
            // Position backdrop absolute and make it span the entire page
            //
            // Also dirty, but we need to tap into the backdrop after Boostrap 
            // positions it but before transitions finish.
            //
            setTimeout( function() {
                jQuery('.modal-backdrop').css({
                    position: 'absolute', 
                    top: 0, 
                    left: 0,
                    width: '100%',
                    height: Math.max(
                        document.body.scrollHeight, document.documentElement.scrollHeight,
                        document.body.offsetHeight, document.documentElement.offsetHeight,
                        document.body.clientHeight, document.documentElement.clientHeight
                    ) + 'px'
                });
            }, 0);
        });
    }

    jQuery(ReactDOM.findDOMNode(this.refs.requestFittingForm)).modal('show');

  },

  showThankYou: function(msg, title, btnText) {
    this.refs.thankWindow.setContent(msg, title, btnText);
    jQuery(ReactDOM.findDOMNode(this.refs.thankWindow)).modal('show');
  },

  showBlocker: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.blockerFiltering)).modal('show');
  },

  hideBlocker: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.blockerFiltering)).modal('hide');
  },

  backToTop: function() {
    jQuery('html, body').animate({ scrollTop: 0 });
  },

  render: function() {
    return <div>
      <NavBar ref="navBar" curPath={this.props.location.pathname}/>
      <RouteTransition pathname={this.props.location.pathname}>
          { React.cloneElement(this.props.children, { addToBag: this.handleAddToBag,
                                                      updateBag: this.handleUpdateBag,
                                                      showFittingReqForm: this.showFittingReqForm,
                                                      showThankYou: this.showThankYou,
                                                      showBlocker: this.showBlocker,
                                                      hideBlocker: this.hideBlocker,
                                                      prevRoute: this.prevRoute,
                                                      key: this.props.location.pathname }) }
      </RouteTransition>
      <div id="back-wrap">
          <div onClick={this.backToTop} id="back-to-top">Back to top</div>
      </div>
      <Footer showFittingReqForm={this.showFittingReqForm}
              showThankYou={this.showThankYou} />
      <RequestFittingForm ref="requestFittingForm" showThankYou={this.showThankYou}/>
      <ThankYou ref="thankWindow" />
      <BlockerFiltering ref="blockerFiltering" />
    </div>
  }
});

ReactDOM.render(<Router history={createBrowserHistory()}>
      <Route path="/" component={Page}>
          <IndexRoute component={Home} ></IndexRoute>
          <Route path="pages/art-of-fit" component={ArtOfFit} ></Route>
          <Route path="collections/mens" component={Mens} ></Route>
          <Route path="collections/womens" component={Womens} ></Route>
          <Route path="collections/:coll/:gender" component={Collection}></Route>
          <Route path="products/:prodHandle" component={ProdDetail}></Route>
          <Route path="pages/stores" component={Stores}></Route>
          <Route path="pages/style-tips" component={StyleTips}></Route>
          <Route path="blogs/:blogType/:postHandle" component={BlogPage}></Route>
          <Route path="pages/search/:terms" component={Search}></Route>
          <Route path="pages/brands-womens" component={BrandsPageW}></Route>
          <Route path="pages/brands-mens" component={BrandsPageM}></Route>
          <Route path="pages/help" component={Help}></Route>
          <Route path="pages/shipping-returns" component={ShippingReturns}></Route>
          <Route path="pages/careers" component={Career}></Route>
          <Route path="pages/privacy-policy" component={Privacy}></Route>
          <Route path="cart" component={BagPage}></Route>
          <Route path="pages/gift-card" component={Giftcard}></Route>
          <Route path="*" component={Home} ></Route>
      </Route>
  </Router>,
  document.getElementById('react-wrapper'));